<template>
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Honk logo</title>
    <path
      d="M61.1321 0C50.7117 0 42.2642 8.4475 42.2642 18.8679C42.2642 29.2883 50.7117 37.7358 61.1321 37.7358C71.5525 37.7358 80 29.2883 80 18.8679C80 8.4475 71.5521 0 61.1321 0ZM61.1321 28.5733C55.7721 28.5733 51.4271 24.2279 51.4271 18.8683C51.4271 13.5083 55.7721 9.16333 61.1321 9.16333C66.4917 9.16333 70.8371 13.5083 70.8371 18.8683C70.8371 24.2279 66.4917 28.5733 61.1321 28.5733Z"
      fill="#570E2D"
    />
    <path
      d="M28.5733 42.2656V66.699L11.7437 42.2656H0V80.0019H9.16292V51.8219L28.5733 80.0019H37.7362V42.2656H28.5733Z"
      fill="#570E2D"
    />
    <path
      d="M69.3278 80.0019H79.9999L64.7466 58.1594L78.9587 42.2656H68.5987L51.4266 62.236V42.2656H42.2637V80.0019H51.4266V73.0548L58.7537 64.8606L69.3278 80.0019Z"
      fill="#570E2D"
    />
    <path
      d="M28.5733 0V14.7879H9.16292V0H0V37.7363H9.16292V22.9483H28.5733V37.7363H37.7362V0H28.5733Z"
      fill="#570E2D"
    />
  </svg>
</template>
